import {jwtDecode} from 'jwt-decode'
import App from '../app/App'
import {AP_CUSTOMER_SOURCE_ID} from '../helpers/misc'
import {pushLoginEvent} from '../helpers/global'

export const GoogleAuthService = {

  decodeCredential(credential) {
    try {
      return jwtDecode(credential)
    } catch (error) {
      console.error('Error decoding Google token:', error)
      throw new Error('Failed to decode Google credential')
    }
  },

  extractUserInfo(credentialResponse) {
    const decoded = this.decodeCredential(credentialResponse.credential)

    return {
      email: decoded.email,
      name: decoded.name,
      given_name: decoded.given_name,
      family_name: decoded.family_name,
      picture: decoded.picture,
      sub: decoded.sub,
      email_verified: decoded.email_verified,
      credential: credentialResponse.credential
    }
  },

  storeUserInfo(googleUserInfo) {
    sessionStorage.setItem('googleUser', JSON.stringify(googleUserInfo))
  },

  getUserInfo() {
    const userInfo = sessionStorage.getItem('googleUser')
    return userInfo ? JSON.parse(userInfo) : null
  },

  clearUserInfo() {
    sessionStorage.removeItem('googleUser')
  },

  handleExistingUserGoogleLogin() {

  },

  async attemptSocialNetworkLogin(googleUserInfo) {
    try {
      const res = await App.instance.$api({
        action: 'social-login',
        method: 'POST',
        data: {
          social_network_credentials: {
            social_network_id: 'google',
            social_network_token: googleUserInfo.sub
          }
        }
      })

      return {
        success: !!res?.customer_id,
        data: res
      }
    } catch (error) {
      console.error('Social network login failed:', error)
      return {
        success: false,
        error: error
      }
    }
  },

  async registerWithGoogle(googleUserInfo) {
    try {
      await App.instance.$api({
        action: 'carecloud_api',
        method: 'POST',
        route: 'customers',
        data: {
          customer: {
            personal_information: {
              first_name: googleUserInfo.given_name,
              last_name: googleUserInfo.family_name,
              email: googleUserInfo.email,
              language_id: 'cs',
              agreement: {
                agreement_gtc: 1,
                agreement_profiling: 1,
                agreement_marketing_communication: 1
              }
            }
          },
          social_network_credentials: {
            social_network_id: 'google',
            social_network_token: googleUserInfo.sub
          },
          autologin: false,
          customer_source: {
            customer_source_id: AP_CUSTOMER_SOURCE_ID
          }
        }
      })

      return {
        success: true,
      }
    } catch (error) {
      console.error('Google registration failed:', error)
      return {
        success: false,
        error: error
      }
    }
  },

  async linkGoogleAccount() {
    const googleUserData = sessionStorage.getItem('googleUser')

    if (googleUserData) {
      const googleUserInfo = JSON.parse(googleUserData)

      if (!googleUserInfo.credential) {
        sessionStorage.removeItem('googleUser')
        return
      }

      try {
        const account = await App.instance.$api({
          action: "carecloud_user_api"
        })

        await App.instance.$api({
          action: "carecloud_user_api",
          method: "PUT",
          data: {
            customer_id: account.customer_id,
            customer: {
              personal_information: account.personal_information
            },
            social_network_credentials: {
              social_network_id: 'google',
              social_network_token: googleUserInfo.sub
            }
          }
        })

        console.log('Google účet úspěšně propojen')

      } catch (error) {
        console.error('Chyba při propojování Google účtu:', error)
      } finally {
        sessionStorage.removeItem('googleUser')
      }
    }
  },

  async handleGoogleLogin($auth, credentialResponse) {
    try {
      const googleUserInfo = this.extractUserInfo(credentialResponse)
      this.storeUserInfo(googleUserInfo)

      //Pokus o přihlášení existujícího účtu
      let socialLoginResult = await this.attemptSocialNetworkLogin(googleUserInfo)

      if (socialLoginResult.success) {
        const touchRes = await $auth.resolveLogin()

        pushLoginEvent(touchRes.customer_id)

        return {
          success: true,
          userInfo: googleUserInfo
        }
      }

      // Registrace nového účtu
      const registerResult = await this.registerWithGoogle(googleUserInfo)
      const registrationFailed = {
        success: false,
        error: 'Registrace se nezdařila',
        userInfo: googleUserInfo
      }

      if (!registerResult.success) {
        const { name, reason } = registerResult.error?.error_data?.invalid_params?.[0] ?? {}

        if (name === 'email' && reason === 'already_exists') {
          return {
            success: false,
            linking: true,
            userInfo: googleUserInfo
          }
        }

        return registrationFailed
      }

      // Přihlášení po registraci
      socialLoginResult = await this.attemptSocialNetworkLogin(googleUserInfo)

      if (!socialLoginResult.success)
        return registrationFailed

      const touchRes = await $auth.resolveLogin()

      pushLoginEvent(touchRes.customer_id)

      return {
        success: true,
        needs_completion: true,
        userInfo: googleUserInfo
      }
    } catch (error) {
      console.error('Error processing Google login:', error)
      return {
        success: false,
        error: error.message
      }
    }
  }
}
